import React, { useEffect, useState } from "react";
import DashboardHeader from "../../../../Components/header/DashboardHeader";
import "../createGroup/CreateGroup.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  Input,
  LoadingButton,
  Select,
  TextArea,
} from "../../../../Components/header/form";
import { imageHandler } from "../../../../utils/imageHandler";
import { edit_icon, img_placehlder, upload_cover } from "../../../../assets";
import { createGroupApi } from "../../../../services/groups";
import multipartDataHelper from "../../../../utils/sendMultipartDataHelper";
import { childGroupMemberListAPi, fetchCategoriesListApi } from "../../../../services/common";
import { toastMessage } from "../../../../utils/toastMessage";
import { CiNoWaitingSign } from "react-icons/ci";
import { useSelector } from "react-redux";

const CreateChildrenGroup = () => {
  const { parentGroupId, adminId } = useParams();
  const [loading, setLoading] = useState(false);
  // const [categoryList, setCategoryList] = useState([]);
  const [memberList, setMemberList] = useState([]);
  const [inputData, setInputData] = useState({ _parent: parentGroupId, });
  const [buttonDisabledButton, setDisabledButton] = useState(true)
  const { showAuth } = useSelector((state) => state?.showAuth);
  const [image, setImage] = useState("");
  const navigate = useNavigate();
  // console.log('showAuth', showAuth)
  // console.log('inputData', inputData)
  // console.log('memberList', memberList)
  //---------handle-change-------------
  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputData({ ...inputData, [name]: value.replace(/^\s+/, "") });
  };
  // console.log('adminId', adminId)
  //   Fetching Category List
  // const fetchCategoryList = async () => {
  //   try {
  //     const { data } = await fetchCategoriesListApi();
  //     const { success, data: response } = data;
  //     if (success) {
  //       setCategoryList(response);
  //     } else {
  //       setCategoryList([]);
  //     }
  //   } catch (e) {
  //     console.log("Error:-", e.message);
  //   }
  // };
  // useEffect(() => {
  //   fetchCategoryList();
  // }, []);

  const addGroupHandler = async () => {
    if (!image || (!image.name && typeof image !== "string")) {
      return toastMessage("Please upload a cover image", "error", "coverImageCreateSubGroup");
    }
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("coverImage", image);
      multipartDataHelper(formData, inputData);

      const { data } = await createGroupApi(formData);
      const { success, message } = data;
      if (success) {
        navigate(-1);
      }
      toastMessage(message, success ? "success" : "error", "addGroupHandler");
    } catch (e) {
      console.log("Error:-", e.message);
    } finally {
      setLoading(false);
    }
  };



  // ------------- validation------------
  const isFormComplete = () => {
    const requiredFields = ["name", "categoryName", "type", "description"];
    if (showAuth?._id === adminId) {
      requiredFields.push("_user"); // Add `_user` field if the condition is true
    }
    const isAllFilled = requiredFields.every((field) => String(inputData[field] || ""));
    if (inputData.type === "SUBSCRIPTION") {
      const subscriptionFields = ["monthlyPrice", "quarterlyPrice", "yearlyPrice"];
      return isAllFilled && subscriptionFields?.every((field) => String(inputData[field] || "")?.trim());
    }
    return isAllFilled;
  };
  // console.log('inputData edit', inputData)
  useEffect(() => {
    setDisabledButton(!isFormComplete());
  }, [inputData]);


  useEffect(() => {
    const fetchMemberList = async () => {
      try {
        const { data } = await childGroupMemberListAPi({ _id: parentGroupId });
        const { success, data: response } = data;
        if (success) {
          setMemberList(response);
        } else {
          setMemberList([]);
        }
      } catch (e) {
        console.log("Error:-", e.message);
      }
    };
    fetchMemberList()
  }, [parentGroupId])
  return (
    <>
      <div className="create_group">
        <DashboardHeader title={"Groups"} />

        <div className="create_group_page">
          <div className="create_grp_Navbar">
            <nav>
              <ul className="_breadcrumb">
                <li className="__breadcrumb_group">
                  <Link to={-1}>Groups </Link>
                </li>
                <li>
                  <span>Create a Group</span>
                </li>
              </ul>
            </nav>
          </div>

          <div className="upload_cover">
            <div className="upload_design">
              <label className="user_icon" htmlFor="file_picker">
                <div className="upload_design_content">
                  <img
                    src={
                      (image?.name && URL.createObjectURL(image)) ||
                      upload_cover
                    }
                  />
                  <div className="upload_design_text">
                    <h3>Upload Cover</h3>
                    <p>(JPG, GIF, PNG. Max size of 800K)</p>
                  </div>
                </div>
                <input
                  type="file"
                  id="file_picker"
                  accept="image/*"
                  onChange={(e) => imageHandler(e, setImage, "image", null)}
                />
                <label htmlFor="profile_picture" className="edit-icon"></label>
              </label>
            </div>

            <div className="form_field_wrap">
              <div className="form-group">
                <Input
                  required
                  label="Group Name"
                  type="text"
                  id="name"
                  name="name"
                  value={inputData?.name}
                  onChange={handleChange}
                  className="input form-control"
                  placeholder="Enter Group Name"
                />
              </div>

              <div className="form-group">
                <Input
                  required
                  label="Category"
                  type="text"
                  id="categoryName"
                  name="categoryName"
                  placeholder="Enter category name"
                  value={inputData?.categoryName}
                  onChange={handleChange}
                  className="input form-control"
                />
              </div>

              <div className="form-group">
                <Select
                  label="Group Type"
                  type="text"
                  id="groupType"
                  name="type"
                  value={inputData?.type}
                  onChange={handleChange}
                  className="input form-control"
                >
                  <option value={""}>Group Type</option>
                  <option value={"PRIVATE"}>Private</option>
                  <option value={"PUBLIC"}>Public</option>
                  <option value={"SUBSCRIPTION"}>Subscription</option>
                </Select>
              </div>
            </div>
            {showAuth?._id === adminId &&
              <div className="form_field_wrap">
                <div className="form-group">
                  <Select
                    label="Assign Admin"
                    type="text"
                    id="groupType"
                    name="_user"
                    value={inputData?._user}
                    onChange={handleChange}
                    className="input form-control"
                  >
                    <option value="" >Assign admin</option>
                    {memberList && memberList.length > 0 ? memberList.map((data, ind) => (
                      <option key={ind} value={data?._user?._id} >{data?._user?.fullName}</option>
                    )) :
                      <option value='' disabled>No Admin</option>
                    }
                  </Select>
                </div>
              </div>}
            {/* -------------if-subscription------------------- */}
            {inputData?.type === 'SUBSCRIPTION' &&
              <>
                <div className="form_field_wrap">
                  <div className="form-group">
                    <Input
                      required
                      label="Monthly"
                      type="text"
                      id="monthly"
                      name="monthlyPrice"
                      value={inputData?.monthlyPrice}
                      onChange={handleChange}
                      className="input form-control"
                      placeholder="Enter enter monthly"
                    />
                  </div>

                  <div className="form-group">
                    <Input
                      required
                      label="Quarterly"
                      type="text"
                      id="quarterly"
                      name="quarterlyPrice"
                      value={inputData?.quarterlyPrice}
                      onChange={handleChange}
                      className="input form-control"
                      placeholder="Enter enter quarterly"
                    />
                  </div>

                  <div className="form-group">
                    <Input
                      required
                      label="Yearly"
                      type="text"
                      id="yearly"
                      name="yearlyPrice"
                      value={inputData?.yearlyPrice}
                      onChange={handleChange}
                      className="input form-control"
                      placeholder="Enter enter yearly"
                    />
                  </div>
                </div>
              </>}
            <div className="form-group textarea">
              <TextArea
                label="Description"
                type="text"
                id="description"
                name="description"
                value={inputData?.description}
                onChange={handleChange}
                className="input form-control"
                placeholder="Write here..."
                // error={error?.nickname}
                rows="6"
              />
            </div>
          </div>

          <LoadingButton
            loading={loading}
            isDisabled={buttonDisabledButton}
            className={buttonDisabledButton ? "cstm_disabled_btn" : ''}
            onClick={addGroupHandler}>
            Create Group
            {/* {buttonDisabledButton ? <CiNoWaitingSign /> : "Create Group"} */}
          </LoadingButton>
        </div>
      </div>
    </>
  );
};

export default CreateChildrenGroup;
